import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/myBusinessIncome";
import commonContent from "../../../../content/common";
import { AWARD_CODES } from "../../../../common/enums/award-codes";

type Props = {
  bonusAwd: number;
  showMonthlyTitle?: boolean;
};

const MBIMetricLegendAwardTranslation = (props: Props) => {
  const { bonusAwd, showMonthlyTitle } = props;
  const { t } = useTranslation(["myBusinessIncome", "common"]);
  const symbol = t("disclaimerSymbol", { ns: "common", defaultValue: commonContent.disclaimerSymbol });

  const getAwardTranslation = (bonusAwd: number) => {
    switch (bonusAwd) {
      // award code 15 mismatch with existing award, keeping 15 here
      case 15:
        return t(
          "metricLegendAwardTranslation.performance",
          defaultContent["metricLegendAwardTranslation"]["performance"],
        );
      case AWARD_CODES.RUBY:
        return t("metricLegendAwardTranslation.ruby", defaultContent["metricLegendAwardTranslation"]["ruby"]);
      case AWARD_CODES.LEADERSHIP:
        return t(
          "metricLegendAwardTranslation.leadership",
          defaultContent["metricLegendAwardTranslation"]["leadership"],
        );
      case AWARD_CODES.DEPTH:
        return t("metricLegendAwardTranslation.depth", defaultContent["metricLegendAwardTranslation"]["depth"]);
      case AWARD_CODES.INTERNATIONAL_LEADERSHIP:
        return t("metricLegendAwardTranslation.intl", defaultContent["metricLegendAwardTranslation"]["intl"]);
      case AWARD_CODES.FOSTER:
        return t("metricLegendAwardTranslation.foster", defaultContent["metricLegendAwardTranslation"]["foster"]);
      case AWARD_CODES.BRONZE_BUILDER:
      case AWARD_CODES.MN_BRONZE_BUILDER:
        return t("metricLegendAwardTranslation.bbi", defaultContent["metricLegendAwardTranslation"]["bbi"], {
          symbol,
        });
      case AWARD_CODES.BRONZE_FOUNDATION:
      case AWARD_CODES.MN_BRONZE_FOUNDATION:
        return t("metricLegendAwardTranslation.bfi", defaultContent["metricLegendAwardTranslation"]["bfi"], {
          symbol,
        });
      case AWARD_CODES.PATH_TO_BRONZE:
        return t("metricLegendAwardTranslation.pbi", defaultContent["metricLegendAwardTranslation"]["pbi"], {
          symbol,
        });
      case AWARD_CODES.STRONG_START_INCENTIVE:
      case AWARD_CODES.STRONG_START_INCENTIVE_MONTH_V2:
        return t("metricLegendAwardTranslation.ssi", defaultContent["metricLegendAwardTranslation"]["ssi"], {
          symbol,
        });
      case AWARD_CODES.CSI:
        return t("metricLegendAwardTranslation.csi", defaultContent["metricLegendAwardTranslation"]["csi"], {
          symbol,
        });
      case AWARD_CODES.MONTHLY_PGG:
        return t("metricLegendAwardTranslation.mpgg", defaultContent["metricLegendAwardTranslation"]["mpgg"], {
          symbol,
        });
      case AWARD_CODES.MONTHLY_Q:
        return t("metricLegendAwardTranslation.monthlyq", defaultContent["metricLegendAwardTranslation"]["monthlyq"], {
          symbol,
        });
      case AWARD_CODES.Q_GROWTH_INCENTIVE:
        return t(
          "metricLegendAwardTranslation.qGrowthIncentive",
          defaultContent["metricLegendAwardTranslation"]["qGrowthIncentive"],
          { symbol },
        );
      case AWARD_CODES.PERFORMANCE_PLUS:
        return t("metricLegendAwardTranslation.pp", defaultContent["metricLegendAwardTranslation"]["pp"], { symbol });
      case AWARD_CODES.PERFORMANCE_ELITE:
        return t("metricLegendAwardTranslation.pe", defaultContent["metricLegendAwardTranslation"]["pe"], { symbol });
      case AWARD_CODES.PERFORMANCE_PLUS_ELITE:
        return t("metricLegendAwardTranslation.pppe", defaultContent["metricLegendAwardTranslation"]["pppe"], {
          symbol,
        });
      case -1:
        return t("metricLegendAwardTranslation.ilbs", defaultContent["metricLegendAwardTranslation"]["ilbs"]);
      case 0:
        return showMonthlyTitle
          ? t("metricLegendAwardTranslation.monthly", defaultContent["metricLegendAwardTranslation"]["monthly"])
          : t("metricLegendAwardTranslation.all", defaultContent["metricLegendAwardTranslation"]["all"]);
      default:
        return "";
    }
  };

  return <>{getAwardTranslation(bonusAwd)}</>;
};

export default MBIMetricLegendAwardTranslation;
